#import "@/components/common/StoryPreviewFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment LargeStoryFeatureWithBarsFragment on largeStoryFeatureWithBars_Entry {
  typeHandle
  heading
  focusStoryTitle
  focusStory {
    uri
    ...StoryPreviewFragment
  }
  focusStoryCta {
    ...LinkFragment
  }
  stories {
    uri
    ...StoryPreviewFragment
  }
}
